<template>
  <div v-if="isMobile" class="mobile-top-header">
    <div class="mobile-top-header__main">
      <router-link to="/" class="mobile-top-header__brand" aria-label="Ir al inicio">
        <img src="/minilogo.png" alt="TusCFDIs" class="mobile-top-header__logo" />
      </router-link>

      <ul class="mobile-top-header__actions">
        <PendingDownloads />
        <Notifications />
        <Profile :icon-only="true" />
      </ul>
    </div>

    <div class="mobile-side-tabs-top" aria-label="Accesos superiores móviles">
      <button
        type="button"
        class="mobile-menu-tab"
        @click="toggleMobileMenu"
        aria-label="Abrir o cerrar menú"
        title="Menú"
      >
        <i class="fa fa-bars"></i>
      </button>
      <button type="button" class="mobile-context-tab" @click="toggleContextDrawer" aria-label="Abrir contexto">
        <i class="fa fa-sliders"></i>
      </button>
    </div>

    <div class="mobile-side-tabs-bottom" aria-label="Accesos fiscales móviles">
      <TaxStatusCertificate class="mobile-side-action" />
      <ComplianceOpinion class="mobile-side-action" />
    </div>

    <teleport to="body">
      <transition name="mobile-context-overlay-fade">
        <div v-if="showContextDrawer" class="mobile-context-overlay" @click="closeContextDrawer"></div>
      </transition>

      <transition name="mobile-context-panel-slide">
        <aside v-if="showContextDrawer" class="mobile-context-panel" role="dialog" aria-modal="true">
          <div class="mobile-context-modal-header">
            <h5 class="mobile-context-modal-title">Selecciona...</h5>
            <button
              type="button"
              class="mobile-context-panel-close"
              @click="closeContextDrawer"
              aria-label="Cerrar contexto"
              title="Cerrar"
            >
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="mobile-context-drawer__body">
            <div class="mobile-context-card">
              <h6>RFC activo</h6>
              <RfcSelector @changed="closeContextDrawer" />
            </div>

            <div class="mobile-context-card">
              <h6>Periodo global</h6>
              <GlobalPeriodSelector width="100%" control-height="46px" @change="closeContextDrawer" />
            </div>
          </div>
        </aside>
      </transition>
    </teleport>
  </div>
</template>

<script>
import PendingDownloads from '@/components/header/pendingDownloads.vue';
import Notifications from '@/components/header/notifications.vue';
import Profile from '@/components/header/profile.vue';
import RfcSelector from '@/components/header/rfcSelector.vue';
import GlobalPeriodSelector from '@/components/global/GlobalPeriodSelector.vue';
import TaxStatusCertificate from '@/components/header/taxStatusCertificate.vue';
import ComplianceOpinion from '@/components/header/complianceOpinion.vue';

export default {
  name: 'MobileTopHeader',
  emits: ['toggle-menu'],
  components: {
    PendingDownloads,
    Notifications,
    Profile,
    RfcSelector,
    GlobalPeriodSelector,
    TaxStatusCertificate,
    ComplianceOpinion,
  },
  props: {
    isMobile: { type: Boolean, default: false },
  },
  data() {
    return {
      showContextDrawer: false,
    };
  },
  watch: {
    $route() {
      this.closeContextDrawer();
    },
    isMobile(next) {
      if (!next) {
        this.closeContextDrawer();
      }
    },
  },
  methods: {
    toggleMobileMenu() {
      this.closeContextDrawer();
      this.$emit('toggle-menu');
    },
    toggleContextDrawer() {
      this.showContextDrawer = !this.showContextDrawer;
    },
    closeContextDrawer() {
      this.showContextDrawer = false;
    },
  },
};
</script>

<style scoped>
.mobile-top-header {
  position: sticky;
  top: 0;
  z-index: 80;
  display: grid;
  gap: 8px;
  padding: 8px 10px;
  background: #ffffff;
  border-bottom: 1px solid rgba(115, 102, 255, 0.2);
  box-shadow: 0 8px 20px rgba(11, 48, 64, 0.08);
}

.mobile-menu-tab {
  border: 0;
  border-radius: 0 12px 12px 0;
  background: var(--theme-deafult);
  color: #fff;
  width: 42px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  box-shadow: 0 8px 20px rgba(11, 48, 64, 0.24);
}

.mobile-side-tabs-top {
  position: fixed;
  left: 0;
  right: auto;
  top: auto;
  bottom: 24px;
  z-index: 90;
  display: grid;
  gap: 8px;
}

.mobile-side-tabs-bottom {
  position: fixed;
  right: 0;
  bottom: 24px;
  z-index: 90;
  display: grid;
  gap: 8px;
}

.mobile-context-tab {
  border: 0;
  border-radius: 0 12px 12px 0;
  background: var(--theme-deafult);
  color: #fff;
  width: 42px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 16px;
  box-shadow: 0 8px 20px rgba(11, 48, 64, 0.24);
}

.mobile-side-tabs-top :deep(.header-notification-nav),
.mobile-side-tabs-bottom :deep(.header-notification-nav) {
  margin: 0;
  position: static;
}

.mobile-side-tabs-top :deep(.header-action-btn),
.mobile-side-tabs-bottom :deep(.header-action-btn) {
  width: 42px;
  min-width: 42px;
  height: 54px;
  min-height: 54px;
  padding: 0;
  border-radius: 12px 0 0 12px;
  border: 0;
  background: var(--theme-deafult);
  box-shadow: 0 8px 20px rgba(11, 48, 64, 0.24);
}

.mobile-side-tabs-top :deep(.header-action-btn i),
.mobile-side-tabs-bottom :deep(.header-action-btn i) {
  color: #fff;
  opacity: 1;
}

.mobile-context-overlay {
  position: fixed;
  inset: 0;
  z-index: 95;
  background: rgba(11, 22, 44, 0.48);
}

.mobile-context-panel {
  position: fixed;
  left: 50%;
  top: 50%;
  right: auto;
  transform: translate(-50%, -50%);
  width: min(92vw, 420px);
  height: auto;
  max-height: min(78vh, 640px);
  background: #fff;
  z-index: 96;
  border-radius: 16px;
  border: 1px solid rgba(115, 102, 255, 0.22);
  box-shadow: 0 18px 36px rgba(11, 48, 64, 0.18);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.mobile-context-modal-header {
  padding: 10px 12px;
  border-bottom: 1px solid rgba(115, 102, 255, 0.14);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobile-context-modal-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #2f2f3b;
}

.mobile-context-panel-close {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid var(--sidebar-border);
  background: #fff;
  color: var(--theme-font-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.mobile-context-panel-close i {
  font-size: 12px;
}

.mobile-context-drawer__body {
  padding: 10px;
  display: grid;
  gap: 10px;
  overflow: visible;
}

.mobile-context-card {
  border: 1px solid var(--sidebar-border);
  border-radius: 12px;
  padding: 10px;
}

.mobile-context-card h6 {
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 700;
  color: var(--theme-deafult);
}

.mobile-context-card :deep(.header-rfc-nav),
.mobile-context-card :deep(.global-period-selector) {
  width: 100%;
}

.mobile-context-card :deep(.header-rfc-nav) {
  display: block;
}

.mobile-context-card :deep(.header-rfc-trigger-card) {
  width: 100%;
  min-height: 46px;
  height: 46px;
  padding: 7px 10px;
}

.mobile-context-card :deep(.header-rfc-trigger-content) {
  text-align: left;
}

.mobile-context-card :deep(.header-rfc-trigger-content > span) {
  font-size: 11px;
}

.mobile-context-card :deep(.header-rfc-trigger-content p) {
  font-size: 10px;
}

.mobile-context-card :deep(.header-rfc-dropdown) {
  position: static;
  top: auto;
  left: auto;
  right: auto;
  margin-top: 8px;
  min-width: 100%;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  max-height: none;
  overflow: visible;
  z-index: 110;
}

.mobile-context-card :deep(.global-period-selector.is-header) {
  --gps-width: 100% !important;
  --gps-control-height: 46px !important;
}

.mobile-context-card :deep(.global-period-selector .ym-select) {
  display: block;
  max-width: none;
}

.mobile-context-card :deep(.global-period-selector .ym-select-dropdown) {
  position: static;
  top: auto;
  left: auto;
  margin-top: 8px;
  width: 100%;
}

.mobile-context-card :deep(.global-period-selector .ym-select-dropdown-inner) {
  max-height: none;
  overflow: visible;
}

.mobile-top-header__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.mobile-top-header__brand {
  display: inline-flex;
  align-items: center;
  gap: 0;
  text-decoration: none;
  color: var(--theme-deafult);
  min-width: 0;
}

.mobile-top-header__logo {
  height: 28px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.mobile-top-header__actions {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-context-overlay-fade-enter-active,
.mobile-context-overlay-fade-leave-active {
  transition: opacity 0.2s ease;
}

.mobile-context-overlay-fade-enter-from,
.mobile-context-overlay-fade-leave-to {
  opacity: 0;
}

.mobile-context-panel-slide-enter-active,
.mobile-context-panel-slide-leave-active {
  transition: opacity 0.24s ease, transform 0.24s ease;
}

.mobile-context-panel-slide-enter-from,
.mobile-context-panel-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, -46%) scale(0.98);
}

@media (min-width: 992px) {
  .mobile-top-header {
    display: none;
  }
}
</style>
